// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"107":"1a517f6a","130":"1333d51e","496":"d9e9ec47","779":"34463647","948":"eca0d687"}[chunkId] + ".chunk.css";
};